{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Voir toutes les options",
  "Spoiler_Reveal_Tooltip": "Cliquez pour afficher",
  "VerticalEmbed_Event_Error_Subtitle": "Cet événement a été supprimé, remplacez‑le par un autre événement.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetez ceci",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "L'élément est réduit",
  "Spoiler_Reveal_Video_CTA": "Révéler la vidéo",
  "VerticalEmbed_Pricing_Plan": "Formule uniquement",
  "Image_Expand_Button_AriaLabel": "Agrandir l'image",
  "VerticalEmbed_From_Price": "À partir de",
  "Poll_Viewer_ShowAllResults_CTA": "Voir tous les résultats",
  "Spoiler_Reveal_Image_Placeholder": "Cette image contient un spoiler",
  "VerticalEmbed_Ribbon": "Promotion",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Curseur",
  "VerticalEmbed_Error_Subtitle": "Cet élément a été supprimé, remplacez‑le par un autre élément.",
  "Poll_Viewer_Multiselect_Footer": "Vous pouvez voter pour plus d'une réponse.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Afficher plus de commandes audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Le service n'a pas pu être chargé",
  "Fullscreen_Close_Button_AriaLabel": "Fermer",
  "VerticalEmbed_Event_Fetch_Error_Title": "L'événement n'a pas pu être chargé",
  "UploadFile_Viewer_Loader": "Chargement {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar de l'utilisateur",
  "Preview_ReadMore_Label": "Lire plus",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "L'article n'a pas pu être chargé",
  "Fullscreen_Shrink_Button_AriaLabel": "Réduire",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "Cette galerie contient un spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Agrandir",
  "VerticalEmbed_Bookings_Button": "Réserver",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Désactiver la mise en sourdine",
  "Spoiler_Reveal_Gallery_CTA": "Révéler la galerie",
  "Poll_Viewer_ShowLess_CTA": "Afficher moins",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Mettre en sourdine",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} anonymes",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Suivre",
  "VerticalEmbed_Products_Button": "Acheter",
  "Poll_Viewer_Toast_Error_ServerDown": "Impossible de se connecter au serveur Veuillez réessayer plus tard.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} personnes ont voté pour cette réponse",
  "Poll_Viewer_VoteCount": "{{number}} votes",
  "VerticalEmbed_Events_Button": "S'inscrire",
  "Spoiler_Reveal_Image_CTA": "Révéler l'image",
  "Poll_Viewer_Toast_Error_Connection": "Pas de connexion internet. Vérifiez votre connexion.",
  "Poll_Viewer_Visibility_Owner_Footer": "Vous seul pouvez voir les résultats.",
  "VerticalEmbed_Booking_Error_Title": "Service supprimé",
  "VerticalEmbed_Product_Error_Title": "Article supprimé",
  "VerticalEmbed_Fetch_Error_Subtitle": "Impossible de charger les informations de l'élément.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personnes ont voté pour cette réponse",
  "VerticalEmbed_Event_Error_Title": "Événement supprimé",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "L'élément est agrandi",
  "Audio_Plugin_Cover_Alt": "Couverture de l'audio",
  "Spoiler_Reveal_Video_Placeholder": "Cette vidéo contient un spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Une erreur technique est survenue. Vérifiez votre connexion puis réessayez.",
  "VerticalEmbed_Fetch_Error_Title": "L'élément n'a pas pu être chargé",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Cet article a été supprimé, remplacez‑le par un autre article.",
  "VerticalEmbed_Booking_Error_Subtitle": "Ce service a été supprimé, remplacez‑le par un autre service.",
  "Preview_SeeFullPost_Label": "Voir le post entier",
  "UploadFile_Viewer_Download": "Télécharger {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Une erreur technique est survenue. Vérifiez votre connexion puis réessayez.",
  "VerticalEmbed_Error_Button": "Remplacer",
  "VerticalEmbed_Error_Title": "Élément supprimé",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Une erreur technique est survenue. Vérifiez votre connexion puis réessayez.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
